import apiSlice from "./api/api";
import { LOANS } from "./ENDPOINTS";

const loanApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all loans (for admin/HR)
    getLoans: builder.query({
      query: ({page, limit = 10, search}) => ({
        url: `${LOANS}/list?page=${page || 1}&limit=${limit}${search ? `&q=${search}` : ''}`,
        method: "GET",
      }),
      providesTags: ["Loans"],
    }),
    // Get my loans (for employee)
    getMyLoans: builder.query({
      query: ({page, limit = 10}) => ({
        url: `${LOANS}/my-loans?page=${page || 1}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["MyLoans"],
    }),
    // Get loan by ID
    getLoan: builder.query({
      query: (id) => ({
        url: `${LOANS}/${id}`,
        method: "GET",
      }),
      providesTags: ["Loan"],
    }),
    // Create loan request
    createLoan: builder.mutation({
      query: (data) => ({
        url: LOANS,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Loans", "MyLoans"],
    }),
    // Update loan
    updateLoan: builder.mutation({
      query: ({id, data}) => ({
        url: `${LOANS}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Loans", "MyLoans", "Loan"],
    }),
    // Approve loan
    approveLoan: builder.mutation({
      query: ({id, remarks}) => ({
        url: `${LOANS}/${id}/approve`,
        method: "PUT",
        body: { remarks },
      }),
      invalidatesTags: ["Loans", "Loan"],
    }),
    // Reject loan
    rejectLoan: builder.mutation({
      query: ({id, remarks}) => ({
        url: `${LOANS}/${id}/reject`,
        method: "PUT",
        body: { remarks },
      }),
      invalidatesTags: ["Loans", "Loan"],
    }),
    // Delete loan
    deleteLoan: builder.mutation({
      query: (id) => ({
        url: `${LOANS}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Loans", "MyLoans"],
    }),
    // Get loan statistics
    getLoanStatistics: builder.query({
      query: () => ({
        url: `${LOANS}/statistics`,
        method: "GET",
      }),
    }),
  })
});

export const {
  useLazyGetLoansQuery,
  useLazyGetMyLoansQuery,
  useGetMyLoansQuery,
  useGetLoanQuery,
  useLazyGetLoanQuery,
  useCreateLoanMutation,
  useUpdateLoanMutation,
  useApproveLoanMutation,
  useRejectLoanMutation,
  useDeleteLoanMutation,
  useLazyGetLoanStatisticsQuery,
} = loanApiSlice;
